export const enum LoginMode {
  'AUTH_TELEGRAM' = 'AUTH_TELEGRAM',
  'AUTH_EMAIL' = 'AUTH_EMAIL',
  'EMAIL_CHOICE' = 'EMAIL_CHOICE',
  'EMAIL_ENTER' = 'EMAIL_ENTER',
  'EMAIL_PASSWORD' = 'EMAIL_PASSWORD',
  'REGISTER_EMAIL' = 'REGISTER_EMAIL',
  'REGISTER_PASSWORD' = 'REGISTER_PASSWORD',
  'CHECK_EMAIL' = 'CHECK_EMAIL',
  'BIND_TELEGRAM' = 'BIND_TELEGRAM',
  'RECOVERY_EMAIL' = 'RECOVERY_EMAIL',
  'RECOVERY_SENT' = 'RECOVERY_SENT',
  'CONFIRM_CODE' = 'CONFIRM_CODE',
}

export const enum LoginScreenContext {
  'menu' = 'menu',
  'order' = 'order',
  'null' = 'null',
}
